"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const index_1 = require("./index");
const react_2 = require("@osmosys/react");
exports.ContentImportPanelOuter = ({ onClose, contentFeed, onChangeContentFeed, isOpen, onContentImport, }) => {
    if (!isOpen) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysOverlay, { onClick: () => {
                onClose();
            } },
            react_1.default.createElement(react_2.OsmosysDiv, { osysName: "ContentImportPanelOuter.InsideOverlay", className: "overflow-hidden w-100", style: {
                    bottom: 0,
                    maxWidth: 460,
                    position: 'absolute',
                    right: 0,
                    top: 0,
                }, flexCol: true },
                react_1.default.createElement(index_1.ContentImportPanel, { usePortal: false, contentFeed: contentFeed, onClose: () => {
                        onClose();
                    }, onChange: onContentImport, onChangeContentFeed: onChangeContentFeed })))));
};
//# sourceMappingURL=Outer.js.map